export const GENERAL_OPTION_IDS = [5, 6, 124];

export const GeneralOptionsLabels: Record<number, string> = {
  [5]: 'Enforce Strategy Customization',
  [6]: 'Enable Support Strategies',
};

export const DEVELOPMENT_AREA_IDS = [7, 8, 9, 10, 11, 12, 13, 14];

export const DevelopmentAreasLabels: Record<number, string> = {
  [7]: 'Social',
  [8]: 'Emotional',
  [9]: 'Communication',
  [10]: 'Receptive Language',
  [11]: 'Expressive Language',
  [12]: 'Academics',
  [13]: 'Independence',
  [14]: 'Motor',
};
